module.exports = __webpack_public_path__ + "img/image166.018dcf6f.png";